import { Observable } from 'rxjs';
import { share } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UrlQueryDef } from '../_appCommon/base/UrlQueryDef';
import { EntityConfig } from '../_appCommon/base/EntityConfig';
import { EntityDataServiceBase } from '../_appCommon/base/EntityDataServiceBase';

@Injectable()
export class CaseDataService extends EntityDataServiceBase
{
  constructor(protected http: HttpClient)
  {
    super(http, 'case');
  }

  protected loadEntityConfig(): void
  {
    this.entityConfig = new EntityConfig();
    this.entityConfig.entityDisplayName = 'case';
    this.entityConfig.apiUrl = 'api/Case';
  }

  public getTotalCustomerCases(requestData: any): Observable<{}>
  {
    let queryDef = new UrlQueryDef();
    let observable = this.http.post(this.createUrl('count'), requestData, queryDef.getRequestConfig(true)).pipe(share());
    return observable;
  }

  public updateProtocolForUseAligners(data: any): Observable<{}>
  {
    let queryDef = new UrlQueryDef();
    let observable = this.http.put(this.createUrl('updateProtocolForUseAligners'), data, queryDef.getRequestConfig(true)).pipe(share());
    this._handleObservableResponse(observable);
    return observable;
  }

  public updateProductId(body: any): Observable<any>
  {
    let queryDef = new UrlQueryDef();
    let observable: Observable<any> = this.http.put(this.createUrl("updateProductId"), body, queryDef.getRequestConfig(true)).pipe(share());
    this._handleObservableResponse(observable);
    return observable;
  }

  public upgradeProduct(body: any): Observable<any>
  {
    let queryDef = new UrlQueryDef();
    let observable: Observable<any> = this.http.put(this.createUrl("upgradeProduct"), body, queryDef.getRequestConfig(true)).pipe(share());
    this._handleObservableResponse(observable);
    return observable;
  }

  public updateCase(body: any): Observable<any>
  {
    let queryDef = new UrlQueryDef();
    let observable: Observable<any> = this.http.put(this.entityConfig.apiUrl, body, queryDef.getRequestConfig(true)).pipe(share());
    this._handleObservableResponse(observable);
    return observable;
  }

  public getAllCasesFiltered(queryDef:UrlQueryDef): Observable<any>{
    let observable = this.http.get(this.createUrl('allCasesFiltered'), queryDef.getRequestConfig(false)).pipe(share());
    return observable;
  }
  
  public getAlignersResumeByCase(queryDef:UrlQueryDef): Observable<any>{
    let observable = this.http.get(this.createUrl('AlignersResumeByCase'), queryDef.getRequestConfig(false)).pipe(share());
    return observable;
  }

  public getUsedAlignersByCase(queryDef:UrlQueryDef): Observable<any>{
    let observable = this.http.get(this.createUrl('UsedAlignersByCase'), queryDef.getRequestConfig(false)).pipe(share());
    return observable;
  }

  public getCaseFromEcommerce(id:number, queryDef:UrlQueryDef): Observable<any>{
    let observable = this.http.get(this.createUrl('FromEcommerce')+`/${id}`, queryDef.getRequestConfig(false)).pipe(share());
    return observable;
  }
}
